import { render, staticRenderFns } from "./formPreview.vue?vue&type=template&id=30bf0a1a&scoped=true&"
import script from "./formPreview.vue?vue&type=script&lang=js&"
export * from "./formPreview.vue?vue&type=script&lang=js&"
import style0 from "./formPreview.vue?vue&type=style&index=0&id=30bf0a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf0a1a",
  null
  
)

export default component.exports